import * as React from 'react';

export function ApiScopeNotice({ title }: { title: string }) {
  return (
    <div className="page" data-testid="api-scope-notice">
      <header className="page-header compact-page-header">
        <div><p className="eyebrow">API SOURCE GATE</p><h1>{title}</h1><p>Этот раздел сохранён в маршрутах, но его Backend API не входит в принятый первый staging slice.</p></div>
      </header>
      <section className="empty-state"><div><h2>API пока не подключён для этого раздела</h2><p>Frontend не подменяет его mock-данными в API mode и не придумывает endpoint.</p></div></section>
    </div>
  );
}
